import { Parser } from "@siteimprove/alfa-parser";
import { Token } from "../../syntax/index.js";
import { Numeric } from "./numeric.js";
const { map } = Parser;
/**
 * {@link https://drafts.csswg.org/css-values/#percentages}
 *
 * @public
 */
export class Percentage extends Numeric {
    static of(value) {
        return new Percentage(value);
    }
    constructor(value) {
        super(value, "percentage");
    }
    scale(factor) {
        return new Percentage(this._value * factor);
    }
    equals(value) {
        return value instanceof Percentage && super.equals(value);
    }
    toJSON() {
        return super.toJSON();
    }
    toString() {
        return `${this._value * 100}%`;
    }
}
/**
 * @public
 */
(function (Percentage) {
    function isPercentage(value) {
        return value instanceof Percentage;
    }
    Percentage.isPercentage = isPercentage;
    Percentage.parse = map(Token.parsePercentage(), (percentage) => Percentage.of(percentage.value));
})(Percentage || (Percentage = {}));
//# sourceMappingURL=percentage.js.map